import { v1ApiClient } from '@/services';
import type { PathParams, ResponseBody } from '@/shared/api/generated';

type SignalsPath = '/v1/workspaces/{workspace_id}/signals';

type GetSignalListParams = Partial<PathParams<SignalsPath, 'get'>>;
type GetSignalListResponse = ResponseBody<SignalsPath, 'get'>;
type GetSignalListFunction = (
  params?: GetSignalListParams,
) => Promise<GetSignalListResponse>;

/**
 * Signal 목록 조회
 */
export const getSignalList: GetSignalListFunction = (props) =>
  v1ApiClient
    .get(`/workspaces/${props?.workspace_id}/signals`)
    .then((res) => res.data);
